import React, { useState } from 'react';
export function FAQSection() {
  const faqs = [{
    q: '¿Cómo recibo el MegaPack después de comprar?',
    a: 'Inmediatamente después del pago recibís un email con el link de descarga. En menos de 5 minutos ya tenés todo descargado en tu dispositivo. 100% PDF, sin apps ni plataformas extras.'
  }, {
    q: '¿Sirve para mi provincia o solo para Buenos Aires?',
    a: 'Sirve para todo el país. El material está alineado al currículo argentino vigente y es adaptable a cualquier provincia. Ya lo usan docentes de Córdoba, Mendoza, Santa Fe, Tucumán, Rosario y todo el interior.'
  }, {
    q: '¿Es editable? ¿Puedo modificarlo?',
    a: 'El material se entrega en PDF de alta calidad. Podés usarlo tal cual (ya está listo) o adaptarlo. Si necesitás versión editable para alguna sección puntual, consultanos.'
  }, {
    q: '¿Los 6 bonos están en todas las ofertas?',
    a: 'Sí. Los 6 bonos están incluidos en las 3 opciones (Física, Química y Pack Completo) sin costo extra.'
  }, {
    q: '¿Puedo comprar solo Física ahora y Química después?',
    a: 'Sí. Podés empezar con la que necesitás y sumar la otra cuando quieras. Aunque el Pack Completo te sale bastante menos que las dos por separado.'
  }, {
    q: '¿Funciona si no tengo laboratorio en la escuela?',
    a: "Sí. El Bono 'Laboratorio Imposible' tiene 25 experiencias diseñadas específicamente para aula común, con materiales cotidianos y sin equipamiento especial."
  }, {
    q: '¿Sirve para cursos difíciles o con mucho desorden?',
    a: 'Sí. Los guiones de clase tienen estructura clara (inicio–desarrollo–cierre) y los bonos incluyen rutinas, roles y warm-ups que ordenan el grupo sin gritar.'
  }, {
    q: '¿Está actualizado al currículo vigente?',
    a: 'Sí. Todo el material está pensado para el currículo argentino de secundaria vigente, con secuencias por año y contenidos organizados.'
  }, {
    q: '¿Tiene garantía real?',
    a: '7 días. Si no te convence, pedís el reembolso y te lo devolvemos sin preguntas. Sin formularios, sin esperas, sin drama.'
  }, {
    q: '¿Qué diferencia tiene el MegaPack con otros materiales que vi?',
    a: 'La mayoría de los materiales que circulan son fragmentos sueltos, sin secuencia, sin evaluación y sin guion. El MegaPack es un sistema anual completo: planificación + guion + experiencias + rúbricas + bonos. Todo articulado, listo y alineado al currículo.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section aria-label="Preguntas frecuentes" className="bg-brand-dark py-32 px-4 border-t border-brand-border" data-id="element-73">
      <div className="max-w-4xl mx-auto" data-id="element-74">
        <h2 className="text-4xl md:text-5xl font-heading font-bold text-center text-white mb-16" data-id="element-75">
          ❓ PREGUNTAS <span className="text-brand-accent" data-id="element-76">FRECUENTES</span>
        </h2>
        <div className="space-y-4" data-id="element-77">
          {faqs.map((faq, i) => <div key={i} className="bg-brand-card rounded-2xl border border-brand-border overflow-hidden" data-id="element-78">
              <button className="w-full px-8 py-6 text-left flex justify-between items-center focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-accent hover:bg-white/5 transition-colors" onClick={() => setOpenIndex(openIndex === i ? null : i)} aria-expanded={openIndex === i} data-id="element-79">
                <span className="font-bold text-white text-lg pr-8" data-id="element-80">
                  <span className="text-brand-accent mr-2" data-id="element-81">{i + 1} —</span>{' '}
                  {faq.q}
                </span>
                <span className={`text-brand-accent text-2xl flex-shrink-0 transition-transform duration-300 leading-none ${openIndex === i ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-82">
                  ▾
                </span>
              </button>
              {openIndex === i && <div role="region" data-id="element-83">
                  <div className="px-8 pb-8 text-white/80 border-t border-brand-border pt-6 text-lg leading-relaxed" data-id="element-84">
                    {faq.a}
                  </div>
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}